"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var LftIconShape_styles_1 = require("./LftIconShape.styles");
var LftIconShape = function (_a) {
    var _b, _c;
    var alt = _a.alt, ariaDescribed = _a.ariaDescribed, ariaLabel = _a.ariaLabel, bgColor = _a.bgColor, icon = _a.icon, id = _a.id, _d = _a.size, size = _d === void 0 ? 'md' : _d;
    var createElementFromHTMLString = function (htmlString) {
        var div = document.createElement('div');
        div.innerHTML = htmlString.trim();
        return div.querySelector('svg');
    };
    var decorateSvgWithA11yProps = function (svg) {
        if (svg) {
            svg.setAttribute('role', 'img');
            svg.setAttribute('alt', alt !== null && alt !== void 0 ? alt : '');
        }
        return svg;
    };
    var html = (_c = (_b = decorateSvgWithA11yProps(createElementFromHTMLString(icon))) === null || _b === void 0 ? void 0 : _b.outerHTML) !== null && _c !== void 0 ? _c : '';
    return ((0, jsx_runtime_1.jsx)(LftIconShape_styles_1.IconShapeSectionStyled, { "aria-describedby": ariaDescribed, "aria-label": ariaLabel, bgColor: bgColor, dangerouslySetInnerHTML: { __html: html }, "data-lift": "lft-iconshape", id: id, size: size }, void 0));
};
exports.default = LftIconShape;
